import { isEqual } from 'lodash-es';

export const hasMeaningfulChanges = (original: Record<string, any>, updated: Record<string, any>): boolean => {
  // Guard: Check if updated has properties that original doesn't have
  for (const key in updated) {
    if (Object.prototype.hasOwnProperty.call(updated, key) && !Object.prototype.hasOwnProperty.call(original, key)) {
      return true;
    }
  }

  // Check for changes in original properties
  for (const key in original) {
    // Guard: Skip if original doesn't own this property
    if (!Object.prototype.hasOwnProperty.call(original, key)) {
      continue;
    }

    // Guard: If updated doesn't have this key, continue (missing properties are ignored)
    if (!Object.prototype.hasOwnProperty.call(updated, key)) {
      continue;
    }

    // Guard: If values are not equal, return true immediately
    if (!isEqual(original[key], updated[key])) {
      return true;
    }
  }

  return false;
};
